module.exports = __webpack_public_path__ + "img/MENU.403cb8d6.svg";